import React, { Component } from 'react'
import PropTypes from 'prop-types';
import FirstPage from './RegistrationSteps/FirstPage'
import SecondPage from './RegistrationSteps/SecondPage'
import ThirdPage from './RegistrationSteps/ThirdPage'
import ForthPage from './RegistrationSteps/ForthPage'
import FifthPage from './RegistrationSteps/FifthPage'
import SixthPage from './RegistrationSteps/SixthPage'
import SeventhPage from './RegistrationSteps/SeventhPage'
import logoLong from '../../assets/cps_new.svg';
import icon_CPS from '../../assets/icon_cps.svg';
import { Field, reduxForm } from 'redux-form'
import { dropdownsRequest } from '../../redux/reducers/dropdowns';
import { checkCodeRequest, resetCodeRequest } from '../../redux/reducers/checkProjectCode';
import { compose, withHandlers, withState, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { shortRegistrationRequest,registrationRequest, loginReset } from '../../redux/reducers/login';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import TextField from '../Form/TextField';
import  validate  from './validateReg';

import Spinner from '../Spinner';
import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput, MDBNotification, MDBSpinner } from "mdbreact";
import PasswordField from './PasswordField';
import EmailField from './EmailField';
import ModalPopup from '../Popups/ModalPopup';
import { COLORS, commonStyles, theme } from '../../styles/styles';

import PropagateLoader from 'react-spinners/PropagateLoader';


class RegistrationForm extends Component {
  constructor(props) {
    super(props)
    this.nextPage = this.nextPage.bind(this)
    this.skipPages = this.skipPages.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.backToOne = this.backToOne.bind(this)
    this.firstCheck = this.firstCheck.bind(this)
    this.state = {
      page: 1,
      formActivePanel1: 1,
      formActivePanel1Changed: false,
      pageTitle:'Personal Information',
      showModal: false
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.checkCode.codeMessage){
      
      if(this.props.checkCode.isFetched == false && !nextProps.checkCode.codeMessage.message){
       
        this.props.shortRegistrationRequest();
      }
     
    }
  }

    
  swapFormActive = (a) => (param) => (e) => {
    
    this.setState({
      ['formActivePanel' + a]: param,
      ['formActivePanel' + a + 'Changed']: true
    });
  }
  swapFormActive2 = (a) => (param)=>{
    
    this.setState({
      ['formActivePanel' + a]: param,
      ['formActivePanel' + a + 'Changed']: true
    });
  }
    
  handleNextPrevClick = (a) => (param) => (e) => {
    this.setState({
      ['formActivePanel' + a]: param,
      ['formActivePanel' + a + 'Changed']: true
    });
  }
    
  handleSubmission = () => {
    alert('Form submitted!');
  }
    
  calculateAutofocus = (a) => {
    if (this.state['formActivePanel' + a + 'Changed']) {
      return true
    }
  }
    
  nextPage = () => {
    
    this.swapFormActive2(1)(this.state.page + 1 )
    this.setState({ page: this.state.page + 1 })
  }

  skipPages = () => {
    this.swapFormActive2(1)(6)
    this.setState({ page: 6 })
  }

  backToOne=()=> {
   
    this.props.resetCodeRequest()
    this.swapFormActive2(1)(1 )
    this.setState({ page: 1 })
  }

  previousPage=()=> {
    if(this.state.page==2){
      this.props.resetCodeRequest()
    }
    this.swapFormActive2(1)(this.state.page - 1 )
    this.setState({ page: this.state.page - 1 })
  }

  setTitle=(title)=> {
    
    this.setState({ pageTitle: title })
  }

  firstCheck=()=> {
     
    // if(this.state.page==1){
      this.props.checkCodeRequest()
  //  }

   
  }

  closeModal = () => {
    this.props.resetCodeRequest();
  }

  render() {
    const { onSubmit,onSubmitShort, onCheck, showLoader, checkCode, login, internet, dropdowns} = this.props
    const { page, pageTitle } = this.state
    
    return (
      <div>
       {(!login.fetchingReg) &&<MDBContainer fluid>
        <div className="mainBg"></div>
      <MDBRow center  style={{alignItems: 'center', display: 'flex', height: '100vh'}}>
        <MDBCol md="6" >
          <MDBCard  style={{marginTop:20, marginBottom:60}}>
              <div className="header text-center  text-dark font-weight-bold pt-4 pb-2" style={{minHeight:70}}>
              {this.state.formActivePanel1 === 1 && (
                <strong>PERSONAL INFORMATION</strong>
              )}
               {this.state.formActivePanel1 === 2 && (
                <strong>CONTACT DETAILS</strong>
              )} 
              {this.state.formActivePanel1 === 3 && (
                <strong>EDUCATION &amp; STATUS</strong>
              )}
               {this.state.formActivePanel1 === 4 && (
                <strong>EDUCATION &amp; STATUS</strong>
              )}
               {this.state.formActivePanel1 === 5 && (
                <strong>LEGAL DECLARATION</strong>
              )}
                {this.state.formActivePanel1 === 6 && (
                <strong>LEGAL DECLARATION</strong>
              )}
              </div>
              <div className='pt-4 pb-4'>
              {(this.state.formActivePanel1 !== 1 && this.state.formActivePanel1 !== 6) && <MDBStepper form>
                <MDBStep form>
                  <a href="#formstep1" >
                    <MDBBtn color={ this.state.formActivePanel1===1 ? "white" : "secondary" } circle className='border border-white'>
                      1
                    </MDBBtn>
                  </a>
                
                </MDBStep>
                <MDBStep form>
                  <a href="#formstep2" >
                    <MDBBtn color={ this.state.formActivePanel1===2 ? "white" : "secondary" } circle className='border border-white'>
                      2
                    </MDBBtn>
                  </a>
                
                </MDBStep>
                <MDBStep form>
                  <a href="#formstep3">
                    <MDBBtn color={ this.state.formActivePanel1===3 ?  "white" : "secondary" } circle className='border border-white'>
                      3
                    </MDBBtn>
                  </a>
                 
                </MDBStep>
                <MDBStep form>
                  <a href="#formstep4">
                    <MDBBtn color={ this.state.formActivePanel1===4 ?  "white" : "secondary" } circle className='border border-white'>
                      4
                    </MDBBtn>
                  </a>
                
                </MDBStep>
                <MDBStep form>
                  <a href="#formstep5" >
                    <MDBBtn color={ this.state.formActivePanel1===5 ?  "white" : "secondary" } circle className='border border-white'>
                      5
                    </MDBBtn>
                  </a>
                 
                </MDBStep>
              </MDBStepper>}
              </div>
              <MDBCardBody>
                <MDBRow>
                  {this.state.formActivePanel1 === 1 && (
                     <FirstPage onSubmit={this.firstCheck} nextPage={this.nextPage} skipPages={this.skipPages}/>
                  )}

                </MDBRow>
             
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        
      </MDBRow>
      {checkCode.fetching && <div style={{position:'absolute', width:'100%', height:'100%', backgroundColor:'rgba(255,255,255,0.7'}}>
        <MDBSpinner primary lg/>
        </div>}
       
      {(checkCode.codeMessage && checkCode.codeMessage.message) && <ModalPopup icon="exclamation-circle" color='secondary' title='Error' body={checkCode.codeMessage.message} showModal={checkCode.codeMessage && checkCode.codeMessage.message} closeModal={this.closeModal} showClose={true}/>
                    
                  
               }

      {(dropdowns.error || checkCode.error) && <ModalPopup icon="exclamation-circle" color='secondary' title='Network Error' body={'Please check your internet connection and refresh the page to continue.'} showModal={dropdowns.error || checkCode.error} closeModal={this.closeModal} showClose={false}/> }

    </MDBContainer>}
    {(login.fetchingReg) && <div style={{backgroundColor:COLORS.cornerstoneRed, width:"100%", height:"100%", position:'absolute', top:0, left:0, zIndex:12000, textAlign: 'center'}}>
     <div style={{textAlign:'center', width:'100%'}}>
      <div style={{ width:400, margin:'0 auto', padding:22}}>
      <h5  style={{color:'#FFFFFF',fontFamily:'PTSans-Regular', width:"100%", textAlign:'center',fontSize:16, marginTop:80}}>Please hang on... we are busy registering you and building your program.</h5>
      <h5  style={{color:'#FFFFFF',fontFamily:'PTSans-Regular', width:"100%", textAlign:'center',fontSize:25, marginTop:30}}>If this is taking too long, please check your internet connectivity and clear your browser cache before refreshing.</h5>
      
      </div>
      </div>
      
      <div style={{position: 'absolute',top: '50%',left: '50%',transform: 'translate(-50%,-50%)',width: 200,height: 200,}}>
      <img src={logoLong} style={{height:100, marginBottom:10}}/>
      <div style={{textAlign:'center', position:'absolute', left:"50%", marginTop:15}}>
        
      <PropagateLoader
         
         sizeUnit={"px"}
         size={15}
         color={'#FFFFFF'}
         loading={true}
       />
      </div>
      <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'center',fontSize:12, marginTop:45}}>LEARN | PERFORM | EXCEL</h5>
     
       <div style={{width:300}}>
        {navigator.connection && <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:45}}>Network Type: {navigator.connection.effectiveType}</h5>}
        {navigator.connection && <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:10}}>Estimated Download Speed: {navigator.connection.downlink} MB/s</h5>}
        {navigator.connection && <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:10}}>Ping: {navigator.connection.rtt} ms</h5>}
        <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:10}}>Actual Download Speed: {internet.downloadSpeed} mb/s</h5>
    
       </div>
        
      </div>
       
    </div>}
   </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  shortRegistrationRequest: () => dispatch(shortRegistrationRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
  checkCodeRequest: () => dispatch(checkCodeRequest()),
  resetCodeRequest: () => dispatch(resetCodeRequest()),
});

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,
  checkCode: state.checkCodeReducer,
  internet:state.checkInternetReducer
});


export default compose(
  reduxForm({  form: 'registration',                 // <------ same form name
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
}),
  withState('showSpinner', 'toggleSpinner', false),
  connect(mapStateToProps, mapDispatchToProps),
  withState('showLoader', 'toggleLoader', false),
  withHandlers({
    onSubmit: props => (values) => {
      const { showLoader } = props;
      //validateRegistration(values);
      //validateLogin(values);
      
      props.toggleLoader(!showLoader);
      props.shortRegistrationRequest();
    },
    onSubmitShort: props => (values) => {
      const { showLoader } = props;
      //validateRegistration(values);
      //validateLogin(values);
      
      props.toggleLoader(!showLoader);
      props.shortRegistrationRequest();
    },
    onCheck: props => (values) => {
      //validateRegistration(values);
      //validateLogin(values);
     
      props.checkCodeRequest();
     
    },
    handleLoader: props => (values) => {
      //validateRegistration(values);
      //validateLogin(values);
     
      
    },
  }),
  lifecycle({
    componentWillMount() {
      
      !this.props.dropdowns.isFetched && this.props.dropdownsRequest();
    },
  }),
)(RegistrationForm);


const styles = () => ({
    ...commonStyles,
    halfField: {
        display: 'inline-flex',
        width: '49%',
    },
    paper: {
      position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      outline: 'none',
    },
    firstInRow: {
        marginRight: '2%',
    },
    fullField: {
        width: '100%',
    },
    regFormWrapper: {
        maxWidth: '80%',
        margin: '0 auto',
    },
    rowWrapper: {
        display: 'flex',
    },
    noTopLabel: {
        paddingTop: 10,
        paddingLeft: 14,
    },
});